<template>
  <div class="h-md-popinfo">
    <template v-if="recordItem.mdCheck == '0'">
      <span class="h-mdCheck red">MD</span>
    </template>
    <template v-else-if="recordItem.mdCheck == '1'">
      <span class="h-mdCheck">无</span>
    </template>
    <template v-else-if="checkAuthCode()">
      <a-popover
        placement="topLeft"
        trigger="click"
        @visibleChange="visibleChange"
      >
        <template slot="content">
          <div class="h-md-popover-content">
            <div class="h-md-pop-header clearfix">
              <div class="md-status"><span class="md-status-dot">MD</span></div>
              <div class="md-h-info">
                <div>审核人：</div>
                <div class="md-h-infos">{{ mdInfoData.userName || "- -" }}</div>
              </div>
              <div class="md-h-info md-h-info2">
                <div>审核时间：</div>
                <div class="md-h-infos">
                  {{ mdInfoData.createTime || "- -" }}
                </div>
              </div>
            </div>
            <div class="h-md-pop-content">
              <div class="md-h-info">
                <div>意见描述：</div>
                <div class="md-h-infos">{{ mdInfoData.mdRemark || "- -" }}</div>
              </div>
            </div>
            <div class="h-md-pop-footer">
              <div class="md-h-info">
                <div>
                  特别提醒：<span class="md-h-infos">{{
                    mdInfoData.mdCheck || "- -"
                  }}</span>
                </div>
              </div>
              <div class="md-h-btn" v-if="!replyVisible">
                <span @click="openReply">回复</span>
              </div>
              <div class="md-h-btn" v-else>
                <span @click="closeReply">取消</span
                ><span @click="submitReply">提交</span>
              </div>
              <a-input
                v-if="replyVisible"
                class="md-h-textarea"
                v-model="commentsContents"
                type="textarea"
              />
            </div>
          </div>
        </template>
        <template
          v-if="!recordItem.mdRoleNames || recordItem.mdRoleNames.length == 0"
        >
          <span class="h-mdCheck red">MD</span>
        </template>
        <template v-else v-for="(rItem, index) in recordItem.mdRoleNames">
          <span v-if="rItem == '测序'" class="h-mdCheck yellow">测</span>
          <span v-if="rItem == '生信'" class="h-mdCheck green">生</span>
          <span v-if="rItem == '医生'" class="h-mdCheck purple">医</span>
          <span v-if="rItem == '无提醒'" class="h-mdCheck">无</span>
          <span v-if="rItem == '未审核'" class="h-mdCheck red">MD</span>
        </template>
      </a-popover>
    </template>
    <template v-else>
      <template v-for="(rItem, index) in recordItem.mdRoleNames">
        <span v-if="rItem == '测序'" class="h-mdCheck yellow">测</span>
        <span v-if="rItem == '生信'" class="h-mdCheck green">生</span>
        <span v-if="rItem == '医生'" class="h-mdCheck purple">医</span>
        <span v-if="rItem == '无提醒'" class="h-mdCheck">无</span>
        <span v-if="rItem == '未审核'" class="h-mdCheck red">MD</span>
      </template>
    </template>
  </div>
</template>

<script>
import auth from "../../directives/auth-utils";

export default {
  props: ["itemId", "recordItem", "authCode"],
  data() {
    return {
      mdInfoData: {},
      replyVisible: false,
      commentsContents: "",
    };
  },
  mounted() {},
  methods: {
    checkAuthCode() {
      return auth.auth(this.authCode);
    },
    openReply() {
      this.replyVisible = true;
    },
    closeReply() {
      this.replyVisible = false;
    },
    submitReply() {
      this.$post(
        "md/addComments",
        {
          contents: this.commentsContents,
          infoId: this.mdInfoData.id,
          parentId: null,
        },
        {
          "Content-Type": "application/json",
        }
      ).then(
        (res) => {
          if (res.data.code == 1) {
            this.replyVisible = false;
            this.$message.success("操作成功");
          } else {
            this.$message.error(res.data.message);
          }
        },
        () => {
          this.$message.error("操作失败");
          this.replyVisible = false;
        }
      );
    },
    visibleChange(visible) {
      this.replyVisible = false;
      if (visible) {
        this.$emit('updateRowsPop');
        this.$get("md/getMdInfo", { itemId: this.itemId }).then((res) => {
          if (res.data.code == 1) {
            this.mdInfoData = res.data.data;
          }
        });
      }else{
        this.$emit('updateRows');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.h-md-pop-content {
  line-height: 18px;
  font-size: 12px;
}
.h-md-pop-header,
.h-md-pop-content,
.h-md-pop-footer {
  border-bottom: 1px dashed #9b9b9b;
  line-height: 18px;
  font-size: 12px;
  padding: 7px 0;
  .md-status {
    float: left;
    width: 20%;
  }
  .md-status-dot {
    width: 38px;
    height: 38px;
    background: #428ef7;
    display: inline-block;
    border-radius: 100%;
    text-align: center;
    line-height: 38px;
    color: #fff;
  }
  .md-h-info {
    float: left;
    width: 30%;
    color: #9b9b9b;
    .md-h-infos {
      color: #162232;
    }
  }
  .md-h-info2 {
    width: 50%;
  }
}

.h-md-pop-content {
  .md-h-info {
    float: inherit;
    width: 100%;
  }
}
.h-md-pop-footer {
  border-bottom: 0;
  padding-bottom: 15px;
  .md-h-info {
    float: left;
    width: 50%;
  }
  .md-h-btn {
    float: right;
    color: #428ef7;
    span {
      margin: 0 5px;
      cursor: pointer;
    }
  }
}
.md-h-textarea {
  margin-top: 10px;
}
.h-popover-style {
  width: 400px;
}
.h-md-popinfo {
  display: inline-block;
  .h-mdCheck {
    cursor: pointer;
    display: inline-block;
    text-align: center;
    padding: 0px 4px 0 4px;
    margin-right: 1px;
    color: #fff;
    background-color: #1890ff;
    line-height: 20px;
    font-size: 12px;
    border-radius: 2px;
    &.grey {
      background-color: #c4c4c4;
      cursor: default;
    }
    &.red {
      background-color: #ff0000;
    }
    &.yellow {
      background-color: #d08b3e;
    }
    &.green {
      background-color: #5a9040;
    }
    &.purple {
      background-color: #7a2e88;
    }
  }
}
.h-md-popover-content {
  width: 320px;
}
</style>